module.exports = __webpack_public_path__ + "media/images/icon_nav_category-939e71bf420ab36dccbf7874e64880ce.svg";